<script>
    import { randString, removeLastWord, getLastWord } from "../../scripts/functions";
    import { getEventsAction } from "../../scripts/utils.js";
    import { current_component, each } from "svelte/internal";
    import arrow from "../../../public/src/svg/section-title-after.svelte";

    const events = getEventsAction(current_component);

    export let disabled = false;
    export let text = "";
    export let showArrow = true
    let localClass;
    while (true) {
        let tempClass = "text-arrow-" + randString(5);
        if (document.getElementsByClassName(tempClass).length === 0) {
            localClass = tempClass;
            break;
        }
    }

</script>

<div class="{localClass} {$$props.class ? $$props.class : ''}"
    class:disabled
    use:events>
    {removeLastWord(text) + " "}
    <span>
        {getLastWord(text)}
        {#if showArrow}
            <div class="carousel-arrow">
                <svelte:component this={arrow} />
            </div>
        {/if}
    </span>
</div>

<style lang="less" global>
    @import "TextArrow.less";
</style>
